import useSWR from 'swr';
import { ArticlesApi } from 'src/services/articles';
import {
  makeArticleSwrKey,
  makeRelatedArticlesSwrKey,
  recentArticlesSwrKey,
} from 'src/constants/swr-keys';

export const useArticleDetailData = (slug: string) => {
  const articlesApi = new ArticlesApi();

  const slugKey = makeArticleSwrKey(slug);
  const searchSlugKey = makeRelatedArticlesSwrKey(slug);

  const { data: articleData, error: articleError } = useSWR(slugKey, () =>
    articlesApi.getArticleBySlug(slug),
  );

  const { data: relatedArticlesData } = useSWR(searchSlugKey, () => {
    const tagSlugs = articleData?.data?.tags.map(tag => tag.slug);

    if (tagSlugs) {
      return articlesApi.searchArticles(tagSlugs);
    }
  });

  const { data: recentArticlesData } = useSWR(
    recentArticlesSwrKey,
    async () => {
      const recentArticlesResponse = await articlesApi.getArticleGroupBySlug(
        'latest',
      );
      return recentArticlesResponse;
    },
  );

  return {
    article: articleData?.data,
    recentArticles: recentArticlesData?.data?.articles?.items,
    relatedArticles: relatedArticlesData?.data?.items,
    error: articleError,
    loading: !articleData && !articleError,
  };
};
